import {cloneDeep} from "lodash";
import {getString} from "Core/helpers/data";
import {RecommendationsListItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {RecommendationsListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new RecommendationsListItemDataObject(
		getString(result, 'uniqueID'),
		getString(result, 'name'),
	);

	return result;
}

// @note There is no output function since list is read only.